<template>
<!-- 自定义设置新界面 -->
<div class="custom_setup">
  <div class="group_left" style="background-color:#ffffff;float:left;padding-right:2%;border-right: 1px solid #dcdee2;" :style="{width:leftWidth,height:leftHeight}">
      <div class="fixed_search">
        <div class="fixed_search_input" style="width:50%" v-if="this.modularCode=='2'" >
          <Select v-model="modularCode" placeholder="模块名称选择" title="模块名称"  @on-change="initSearch(true)">
            <Option v-for="(option, index) in modularList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
        </div>
        <div class="fixed_operation_btn">

          <Button type="info" style="margin-right: 10px" @click="addGroupData">添加</Button>
          <!-- <Button type="primary" style="margin-right: 10px">保存</Button> -->
          <!-- <Button type="error">删除</Button> -->
        </div>
      </div>
      <div class="fixed_table">
        <div class="table_head">
          <table>
            <tr>
              <!-- <th class="font_style_set" style="width:5%;"><Checkbox v-model="checkedAll"  @on-change="checkedAllGoup()"></Checkbox></th> -->
              <th class="font_style_set" style="width:30%;">组名称</th>
              <th class="font_style_set" style="width:30%;">组备注</th>
              <th class="font_style_set" style="width:20%;">组排序</th>
              <th class="font_style_set" style="width:20%;">操作</th>
            </tr>
          </table>
        </div>
        <div class="footer_style" :style="tableHeight">
          <table class="table_head_footer">
            <tr v-for="(item , index) in customGroupList" :key="index+1" :id="'customGroup'+item.id" :class="{back_color:(index+1)%2==0}" @click="getForm(item.id)">
              <!-- <td  style="width:5%;"><CheckboxGroup v-model="singleCheckedList"><Checkbox :label="item.id"></Checkbox></CheckboxGroup></td> -->
              <td  style="width:30%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="item.groupName"><input class="group_input" placeholder="请输入组名称" :value="item.groupName" ref="groupName" name="groupName" @change="editName(index,item.id)"/></td>
              <td  style="width:30%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="item.groupDesc"><input class="group_input" placeholder="请输入组备注" :value="item.groupDesc" ref="remarks" name="remarks"  @change="editRemarks(index,item.id)"/></td>
              <td  style="width:20%;"><input class="group_input" placeholder="请输入组排序" :value="item.sort" ref="sort" name="sort" @change="editSort(index,item.id)"/></td>
              <td  style="width:20%;" class="template_table_btn">
                <span class="search_btn" :class="{ 'notClick' : item.id == '2' }" @click=" item.id != '2' && deleteGroup(item.id,index)">删除</span>
              </td>

            </tr>
          </table>
        </div>
      </div>

  </div>
  <div class="definition_config" style="background-color:#ffffff;float:right;padding-left:2%" :style="{width:rightWidth}">
    <div class="fixed_search">
      <div class="fixed_search_input" v-show="this.modularCode!='2'">
          <Select v-model="modularCode" placeholder="模块名称选择"  title="模块名称"  @on-change="initSearch(true)">
            <Option v-for="(option, index) in modularList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
      </div>
      <div class="fixed_search_input">
        <Input v-model="customName" placeholder="请输入显示名称" title="显示名称"/>
      </div>
      <div class="fixed_search_input">
        <Select v-model="customIsShow" placeholder="是否列表显示" title="是否显示" clearable>
          <Option v-for="(option, index) in judgeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select v-model="customIsSearch" placeholder="是否搜索" title="是否搜索" clearable>
          <Option v-for="(option, index) in IsSearchList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select v-model="customIsUse" placeholder="是否启用" title="是否启用" clearable>
          <Option v-for="(option, index) in customIsUseList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input" v-if="this.modularCode=='2'">
        <Select v-model="isGeneralField" placeholder="是否通用字段" title="是否通用字段" clearable>
          <Option v-for="(option, index) in customGeneralFieldList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="reset_btn" @click="reset">重置</Button>
        <Button type="info" style="margin-left: 10px" @click="addCustom" v-if="roleList['3_2-1']">添加</Button>
      </div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="table_head">
        <table>
          <tr>
            <th class="font_style_set" style="width:7%;">字段类型</th>
            <th class="font_style_set" style="width:15%;">字段名称</th>
            <th class="font_style_set" style="width:15%;">显示名称</th>
            <th class="font_style_set" style="width:8%;">列表显示</th>
            <th class="font_style_set" style="width:5%;">唯一</th>
            <th class="font_style_set" style="width:5%;">必填</th>
            <th class="font_style_set" style="width:8%;">搜索
              <el-tooltip class="el_tips_font" effect="light" placement="top">
                <div slot="content">
                  属性值为【高级搜索】的字段在页面显示时将直接出现在高级搜索中<br/>
                  属性值为【是】的字段将根据排序在页面搜索区域显示:<br/>
                  当页面搜索区域字段数超过十个时，其余字段将在高级搜索中显示<br/>
                </div>
                <img :src="questionMark"/>
              </el-tooltip>
            </th>
            <th class="font_style_set" style="width:9%;" v-if="modularCode == '2'">通用字段
              <el-tooltip class="el_tips_font" effect="light" placement="top">
                <div slot="content">
                  属性值为【是】的字段将在工单页面中进行展示，且工单类型扩展表单将不能再引用此字段<br/>
                  属性值为【否】的字段默认不在工单页面中展示，需要在工单类型扩展表单中配置后展示<br/>
                </div>
                <img :src="questionMark"/>
              </el-tooltip>
            </th>
            <th class="font_style_set" style="width:8%;" v-if="modularCode == '2'">所属分组</th>
            <th class="font_style_set" style="width:5%;">排序</th>
            <th class="font_style_set" style="width:15%;border-right: 0px"  v-if="roleList['3_2-2'] || roleList['3_2-3'] || roleList['3_2-4']">操作</th>
          </tr>
        </table>
      </div>
      <div style="border-bottom: 1px solid rgb(235, 238, 245);" class="footer_style" :style="tableHeight">
        <table class="table_head_footer" v-if="infoTableList.length>0">
          <tr v-for="(item , index) in infoTableList" :key="index" v-show="'serviceNextTime' != item.customColName && 'serviceGroup' != item.customColName" :id="item.id" :class="{back_color:(index+1)%2==0}">
            <td  style="width:7%;">{{item.fieldName}}</td>
            <td class="font_style_set" style="width:15%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="item.systemName">{{item.systemName}}</td>
            <td style="width:15%;">
              <input :value="item.customName" class="custom_input_select" :id="item.moduleId+'_'+index+'customName'+item.id" @change="saveCustomAttribute(item.moduleId+'_'+index+'customName'+item.id,item.id,'customName')"/>
            </td>
            <td  style="width:8%;">
              <select v-model="item.customIsShow" class="custom_input_select" :id="item.moduleId+'_'+index+'customIsShow'+item.id" @change="saveCustomAttribute(item.moduleId+'_'+index+'customIsShow'+item.id,item.id,'customIsShow')">
                <option value="0">否</option>
                <option value="1">是</option>
              </select>
            </td>
          <td  style="width:5%;">
              <select v-model="item.customIsUnique" :disabled="item.customType==='file' || 'employeeId' == item.customColName || 'creator' == item.customColName || 'status' == item.customColName  || 'shareTime' == item.customColName || 'shareStatus' == item.customColName  || 'createTime' == item.customColName || 'lastConnectTime' == item.customColName || 'nextConnectTime' == item.customColName || 'allocateTime' == item.customColName||'orderType' == item.customColName||'orderLabel' == item.customColName||'orderChannel' == item.customColName||'orderLevel' == item.customColName||'orderState' == item.customColName||'serviceGroup' == item.customColName||'customerPhone' == item.customColName||'customerName' == item.customColName" class="custom_input_select" :id="item.moduleId+'_'+index+'customIsUnique'+item.id" @change="saveCustomAttribute(item.moduleId+'_'+index+'customIsUnique'+item.id,item.id,'customIsUnique')">
                <option value="0" selected="selected">否</option>
                <option value="1">是</option>
              </select>
            </td>
            <td  style="width:5%;">
              <select class="custom_input_select" v-model="item.customIsMust" :disabled="item.customType==='file' || 'employeeId' == item.customColName || 'creator' == item.customColName || 'status' == item.customColName  || 'shareTime' == item.customColName  || 'shareStatus' == item.customColName  || 'createTime' == item.customColName || 'lastConnectTime' == item.customColName || 'allocateTime' == item.customColName || 'orderChannel' == item.customColName || 'orderHandler' == item.customColName|| 'orderState' == item.customColName || 'orderTheme' == item.customColName || 'orderDescribe' == item.customColName" :id="item.moduleId+'_'+index+'customIsMust'+item.id" @change="saveCustomAttribute(item.moduleId+'_'+index+'customIsMust'+item.id,item.id,'customIsMust')">
                <option value="0" selected="selected">否</option>
                <option value="1">是</option>
              </select>
            </td>
            <td  style="width:8%;">
              <select class="custom_input_select" v-model="item.customIsSearch" :disabled="item.customType==='file'" :id="item.moduleId+'_'+index+'customIsSearch'+item.id" @change="saveCustomAttribute(item.moduleId+'_'+index+'customIsSearch'+item.id,item.id,'customIsSearch')">
                <option value="0">否</option>
                <option value="1">是</option>
                <option value="2">高级搜索</option>
              </select>

            </td>
            <td  style="width:9%;" v-if="modularCode == '2'">
              <select :disabled="item.customColName == 'orderHandler' || item.customColName == 'orderChannel' || item.customColName == 'orderState' || item.customColName == 'orderLabel' || item.customColName == 'orderTheme' || item.customColName == 'orderDescribe'" v-model="item.generalField" class="custom_input_select" :id="item.moduleId+'_'+index+'generalField'+item.id" @change="saveCustomAttribute(item.moduleId+'_'+index+'generalField'+item.id,item.id,'generalField')">
                <option value="0" selected="selected">否</option>
                <option value="1">是</option>
              </select>
            </td>
            <td  style="width:8%;" v-if="modularCode == '2'">
              <select class="custom_input_select" v-model="item.groupId" :id="item.moduleId+'_'+index+'groupId'+item.id" @change="saveCustomAttribute(item.moduleId+'_'+index+'groupId'+item.id,item.id,'groupId')">
                <option v-for="(groupItem,index) in customGroupList" :key="groupItem.id" :value="groupItem.id">{{groupItem.groupName}}</option>
              </select>
            </td>
            <td  style="width:5%;">
              <input :value="item.customPosition" class="custom_input_select" :id="item.moduleId+'_'+index+'customPosition'+item.id" @change="saveCustomAttribute(item.moduleId+'_'+index+'customPosition'+item.id,item.id,'customPosition')"/>
            </td>
            <td class="template_table_btn" style="width:15%;" v-if="roleList['3_2-2'] || roleList['3_2-3'] || roleList['3_2-4'] ">
              <span v-if="item.customColName!='customerManager' && item.customColName!='status' && item.customColName!='creator' && item.customColName!='shareStatus' && item.customColName!='customerName'&& item.customColName!='orderHandler'&& item.customColName!='serviceGroup'&& item.customColName!='copyEmpId'">
                <span v-show="item.customColName != 'employeeId'" v-if="(item.customType=='select' || item.customType=='radio'  || item.customType=='checkbox') && roleList['3_2-4']" class="search_btn" @click="editCustom(item.id,item.moduleId,item.customIsUse,item.customColName)">编辑</span>
              </span>
              <span v-if="item.customIsSystem=='0' && roleList['3_2-2']" class="search_btn" @click="deleteCustom(item.id,item.customIsUse)">删除</span>
              <span v-if="item.customIsUse==0 &&  roleList['3_2-3']" class="search_btn" @click="saveCustomIsUse('1',item.id,'启用',item.customName)">启用</span>
              <span v-if="item.customIsUse!=0 &&  roleList['3_2-3']" class="search_btn" :class="{ 'notClick' : item.customColName == 'orderHandler' || item.customColName == 'orderChannel' || item.customColName == 'orderState' || item.customColName == 'orderLabel' || item.customColName == 'orderTheme' || item.customColName == 'orderDescribe' }" @click=" item.customColName != 'orderHandler' && item.customColName != 'orderChannel' && item.customColName != 'orderState' && item.customColName != 'orderLabel'&& item.customColName != 'orderTheme'&& item.customColName != 'orderDescribe' && saveCustomIsUse('0',item.id,'禁用',item.customName)">禁用</span>
            </td>
          </tr>
        </table>
      </div>
      <div class="page_style">
        <Page :total="total" size="small"  :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
        <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
      </div>
      <definitionConfigPop :showDefinitionEdit="showDefinitionEdit" @closeDefinitionEdit="closeDefinitionEdit" :modularCode="modularCode" :groupId="groupId" :customGroupList="customGroupList"></definitionConfigPop>
      <editSelectDataDictPop :showDataDictEdit="showDataDictEdit" :dictCode="dictCode" :dictType="dictType" :moduleId="moduleId" :dictIsUse="dictIsUse" @closeDataDictPop="closeDataDictPop"></editSelectDataDictPop>
    </div>
  </div>
</div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import definitionConfigPop from '@/components/systemSetup/DefinitionConfigPop.vue'
    import editSelectDataDictPop from '@/components/systemSetup/EditSelectDataDictPop.vue'
    export default {
        name: "customSetup",
        mixins:[publicFunClass],
        components:{
          definitionConfigPop,
          editSelectDataDictPop
        },
        props:{
          pageCode:String
        },
        data(){
          return{
            showPageCount:0,
            tableHeight:{height:''},
            leftHeight:'0',
            leftWidth:"0",
            rightWidth:"100%",
            customName:'',
            modularCode:'1',
            modularList:[{'id':'1','name':'客户管理'},{'id':'2','name':'工单管理'},{'id':'3','name':'服务管理'}],
            judgeList:[{'id':'0','name':'否'},{'id':'1','name':'是'}],
            IsSearchList:[{'id':'0','name':'否'},{'id':'1','name':'是'},{'id':'2','name':'高级搜索'}],
            customIsUse:'',
            customIsUseList:[{'id':'0','name':'禁用'},{'id':'1','name':'启用'}],
            customGeneralFieldList:[{'id':'0','name':'否'},{'id':'1','name':'是'}],
            customIsShow:'',
            spinShow:true,
            customIsSearch:'',
            checkedAll:false,
            showDefinitionEdit:false,
            showDataDictEdit:false,
            total:0,
            pageSizeList:[10,20,30,40,50,100,200],
            currentPage:1,
            speedChangePage: 1,
            pageSize:20,
            resultList:[],
            dictCode:'',
            dictType:'', //字段类型
            moduleId:'',
            dictIsUse:'',
            roleList:JSON.parse(localStorage.getItem("roleList")),
            infoTableList:[],
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            questionMark:require('../../assets/image/homeAsk.png'),
            customEnum:{
              telephoneOne:"手机号码",
              telephoneTwo:"手机号码2",
              customerName:"客户名称",
              customerManager:"客户经理",
              customerType:"客户类型",
              telephoneThree:"手机号码3",
              telephoneFour:"手机号码4",
              telephoneFive:"手机号码5",
              lastConnectTime:"最后联系时间",
              nextConnectTime:"下次联系时间",
              allocateTime:"分配时间",
              applyTime:"申请时间",
              createTime:"创建时间",
              shareStatus:"共享状态",
              shareTime:"共享时间",
              creator:"创建人员",
              status:"回访状态",
              customerEmail:"客户邮箱",
              // 服务
              serviceChannel:"服务渠道",
              serviceDescr:"服务备注",
              employeeId:"员工姓名",
              customerId:"客户名称",
              serviceNextTime:"下次联系时间",
              employeeId:"员工姓名",
              // 工单
              orderTheme:"主题",
              orderDescribe:"描述",
              customerPhone:"客户手机号",
              orderHandler:"处理人",
              copyEmpId:"抄送人",
              orderState:"状态",
              orderLevel:"优先级",
              orderChannel:"渠道",
              orderLabel:"标签",
              orderType:"工单类型",
            },
            sysSupportWorkOrder: JSON.parse(localStorage.getItem("sysSupportWorkOrder")),
            singleCheckedList:[],
            customGroupList:[],
            issave:'0',
            groupId:'',
            isGeneralField:'',
          }
        },
        methods:{
          saveCustomIsUse:function(demoId,id,name,customName){
            let moduleName = '客户管理';
            let modularCode = this.modularCode;
            if('2' == modularCode){
              moduleName = '工单管理';
            }else if('3' == modularCode){
              moduleName = '服务管理';
            }
           let param={
              id:id,
              customIsUse:demoId,
              journalType:"系统管理=>自定义设置=>"+moduleName+"=>"+name+customName,
              menuId:"3_2-3"
            };
           let that=this;
            this.$Modal.confirm({
              title: '提示',
              content: "是否确定"+name+customName,
              onOk: () => {
                that.$http.post("custom/update-field.json",param) .then(function (res) {
                  let result=res.data.flag;
                  if(result!="666"){
                    that.$alert(res.data.msg, '提示', {
                      confirmButtonText: '确定'
                    });
                    return false;
                  }
                  that.$Message.info("修改成功");
                  that.initSearch();
                })
              }
            });
          },
          editCustom:function(id,moduleId,dictIsUse,customColName){
            this.dictType = customColName;
            this.dictCode = id+"";
            this.moduleId = moduleId+"";
            this.dictIsUse = dictIsUse+"";
            this.showDataDictEdit=true;
          },
          closeDataDictPop:function(){
            this.showDataDictEdit=false;
          },
          deleteCustom:function(id,customIsUse){
            let that=this;
            let param={
              journalType:"系统管理=>自定义设置=>删除",
              menuId:"3_2-2",
              id:id
            };
            let content="删除后将无法恢复,是否确定删除";
            if(customIsUse=='1'){
              content="该字段正在使用,删除后将无法恢复,是否确定删除";
            }
            this.$Modal.confirm({
              title: '提示',
              content:content,
              onOk: () => {
                that.$http.post("custom/delete-field.json",param) .then(function (res) {
                  let result=res.data.flag;
                  if(result!="666"){
                    that.$alert(res.data.msg, '提示', {
                      confirmButtonText: '确定'
                    });
                    return false;
                  }
                  that.$Message.info("删除成功");
                  that.initSearch();
                })
              }
            });
          },
          saveCustomAttribute:function(demoId,id,name){
            let param='';
            if(name=='customName'){
              let customName=document.getElementById(demoId).value;
              if (!customName){
                this.$Message.info("字段名称不能空");
                return false
              }else if(customName.length > 19){
                this.$Message.info("显示名称最多仅支持19个字符");
                return false;
              }
              param={
                id:id,
                customName:customName,
                journalType:"编辑显示名称",
                menuId:"null"
              }
            }
            if(name=='customPosition'){
              let customPosition=document.getElementById(demoId).value;
              if (!customPosition){
                this.$Message.info("排序不能空");
                return false
              }
              if (parseInt(customPosition)<0){
                this.$Message.info("排序不能小于0");
                return false
              }
              param={
                id:id,
                customPosition:customPosition,
                journalType:"编辑排序",
                menuId:"null"
              }
            }
            if(name=='customIsShow'){
              param={
                id:id,
                customIsShow:document.getElementById(demoId).value,
                journalType:"编辑是否列表显示",
                menuId:"null"
              }
            }
            if(name=='customIsUnique'){
              param={
                id:id,
                customIsUnique:document.getElementById(demoId).value,
                journalType:"编辑是否唯一",
                menuId:"null"
              }
            }
            if(name=='customIsMust'){
              param={
                id:id,
                customIsMust:document.getElementById(demoId).value,
                journalType:"编辑是否必填",
                menuId:"null"
              }
            }
            if(name=='customIsSearch'){
              let value=document.getElementById(demoId).value;
              param={
                id:id,
                customIsSearch:value,
                journalType:"编辑是否提供搜索",
                menuId:"null"
              }
            }
            if(name=='customIsSort'){
              param={
                id:id,
                customIsSort:document.getElementById(demoId).value,
                journalType:"编辑列表排序",
                menuId:"null"
              }
            }
            if(name=='generalField'){
              param={
                id:id,
                generalField:document.getElementById(demoId).value,
                journalType:"编辑通用字段",
                menuId:"null"
              }
            }
            if(name=='groupId'){
              param={
                id:id,
                groupId:document.getElementById(demoId).value,
                journalType:"编辑所属分组",
                menuId:"null"
              }
            }
            let moduleName = '客户管理';
            let modularCode = this.modularCode;
            if('2' == modularCode){
              moduleName = '工单管理';
            }else if('3' == modularCode){
              moduleName = '服务管理';
            }
            param.journalType = "系统管理=>自定义设置=>"+moduleName+"=>"+param.journalType;
            let that=this;
            this.$http.post("custom/update-field.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.$Message.info("已保存成功");
              that.initSearch();
            })
          },

          closeDefinitionEdit:function(flag){
            this.showDefinitionEdit=false;
            if(flag){
              this.initSearch();
            }
          },
          reset:function () {
            //  this.modularCode='1';
             this.customName='';
             this.customIsShow='';
             this.customIsSearch='';
             this.customIsUse="";
             this.isGeneralField = "";
          },
          addCustom:function () {
            if(this.modularCode=='2' && !this.groupId){
              this.$Message.info("请先选择组名称");
              return false;
            }
            this.showDefinitionEdit=true;
          },
          initSearch:function () {
            if(this.modularCode=='2'){
              this.leftWidth="30%";
              this.leftHeight=this.mountHeight(92);
              this.rightWidth="70%";

              this.initFieldGroup();
              if(!this.groupId){
                this.infoTableList = [];
              }

            }else{
              this.leftWidth="0";
              this.leftHeight="0";
              this.rightWidth="100%";
            }
            // 查询自定义分组
            if(this.modularCode!='2' || (this.modularCode=='2' && this.groupId)){
              this.initField();
            }
          },
          // 自定义字段查询
          initField:function(){
            this.infoTableList=[];
            this.spinShow=true;
            let param={
              moduleId:this.modularCode,//模块id
              customName:this.customName,//显示名称
              customIsShow:this.customIsShow,//是否显示
              customIsSearch:this.customIsSearch,//是否搜索
              customIsUse:this.customIsUse,
              generalField:this.isGeneralField, //是否通用字段
              pageNum:this.currentPage,
              pageSize:this.pageSize,
              groupId:this.modularCode=='2' ? this.groupId : '',
              journalType:"null",
              menuId:"null"
            };
            let that=this;
            this.$http.post("custom/fields.json",param) .then(function (res) {
              that.spinShow=false;
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.infoTableList=res.data.obj.list.content;
              if(that.infoTableList && that.infoTableList.length > 0){
                for (let i=0;i < that.infoTableList.length;i++){
                  let systemName = that.infoTableList[i].customColName;
                  systemName = that.customEnum[systemName];
                  if(!systemName){
                    systemName = that.infoTableList[i].customName;
                  }
                  that.infoTableList[i].systemName = systemName;
                }
              }
              that.total=res.data.obj.list.totalSize;
            })
          },
          // 自定义分组查询
          initFieldGroup: function(){
            let that=this;
            this.spinShow=true;
            let param={
              moduleId:this.modularCode,//模块id
              journalType:"null",
              menuId:"null"
            };
            this.$http.post("fieldGroup/toIndex.json",param) .then(function (res) {
              that.spinShow=false;
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.customGroupList=res.data.obj.list;
            })
          },

          //添加分组
          addGroupData:function(){
            let param={
                  id:"",
                  groupName:"",
                  remarks:"",
                  sort:"",
            };
            this.customGroupList.push(param);
          },
          //删除分组
          deleteGroup:function (id,index) {
            if(!id){
              this.customGroupList.splice(index,1);
              return;
            }

            let that=this;
            this.spinShow=true;
            let param={
              id:id,//模块id
              journalType:"系统管理=>自定义设置=>删除组",
              menuId:"3_2-2",
            };
            this.$http.post("fieldGroup/doDelete.json",param) .then(function (res) {
              that.spinShow=false;
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.$Message.success("删除成功！");
              that.initFieldGroup();
            })
          },
          //编辑
          editName:function(index,id){
            let value=this.$refs.groupName[index].value;
            if(!value){
                  this.$Modal.info({
                    title:'提示',
                    content:"组名称不能为空"
                  });
                  return false;
            }

            let that=this;
            this.spinShow=true;
            let param={
              id:id,//模块id
              groupName: value,
              moduleId: this.modularCode,
              journalType: id ? "系统管理=>自定义设置=>编辑组名称" : "系统管理=>自定义设置=>编辑添加组",
              menuId:"null",
            };
            this.$http.post("fieldGroup/doSave.json",param) .then(function (res) {
              that.spinShow=false;
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.$Message.success("操作成功");
              that.initFieldGroup();
            })
          },
          editRemarks:function(index,id){
            let value=this.$refs.remarks[index].value;
            let that=this;
            this.spinShow=true;
            let param={
              id:id,
              groupDesc:value,
              journalType:"系统管理=>自定义设置=>编辑组备注",
              menuId:"null",
            };
            this.$http.post("fieldGroup/doSave.json",param) .then(function (res) {
              that.spinShow=false;
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.$Message.success("保存成功");
              that.initFieldGroup();
            })

          },
          editSort:function(index,id){

            let value=this.$refs.sort[index].value;
            if(!value){
                  this.$Modal.info({
                    title:'提示',
                    content:"组排序不能为空"
                  });
                  return false;
            }
            let that=this;
            this.spinShow=true;
            let param={
              id:id,
              sort: value,
              journalType:"系统管理=>自定义设置=>编辑组排序",
              menuId:"null",
            };
            this.$http.post("fieldGroup/doSave.json",param) .then(function (res) {
              that.spinShow=false;
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.$Message.success("保存成功");
              that.initFieldGroup();
            })
          },
          //点击分组行
          getForm(id){
            for(let i=0;i<this.customGroupList.length;i++){
              let tableId='customGroup'+this.customGroupList[i].id;
              document.getElementById(tableId).style.backgroundColor="transparent"
            }
            document.getElementById('customGroup'+id).style.backgroundColor="#c8e0fb"
            this.groupId = id;
            this.initField();

          }
        },
        created(){
          this.initSearch();
          this.tableHeight.height=this.mountHeight(222);
          //this.typeHeight=this.mountHeight(92);
        },
        watch:{
          pageCode:function () {
            if(this.pageCode=='3_2' && this.showPageCount==0){
              this.showPageCount++;

              if("0" == this.sysSupportWorkOrder){
                this.modularList.splice(1, 1);
              }
            }
          },
        }
    }
</script>

<style scoped lang="less">
.custom_setup{
  background-color:#ffffff  !important;
}
.group_left{
  .headline{
    height:30px;
    display:flex;
    justify-content:space-between;
    align-items:center;
    background-color:#ffffff;
    .line{
    	  height:2px;
    	  background-color:#e7e7e4;
    		flex-grow:1;
    }
    .text{
        top:0;
        color:black;
        transform:translateY(0px);
    }
  }
}
.group_input{
   background-color: inherit;width: 90%;text-align: center;border: 0px;box-shadow: none;
}
.notClick{
  color: #C0C4CC !important;
  cursor: not-allowed !important;
}
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/customSetup.vue